import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import desktopDiagonal from "../images/assets/desktop-diagonal.svg";
import mobileDiagonal from "../images/assets/mobile-diagonal.svg";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  overflow: hidden;
  position: relative;
`;

const StlInner = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 730px) {
    min-height: 800px;
  }

  @media (min-width: 900px) {
    min-height: 640px;
  }
`;

const StlImagePanel = styled.div`
  position: relative;
  height: 623px;
  overflow: hidden;

  @media (min-width: 900px) {
    min-height: 640px;
  }
`;

const StlBackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${(props) =>
    props.imageUrl ? `url(${props.imageUrl})` : "none"};
  background-size: cover;
  background-position: center;
`;

const StlCopyPanel = styled.div`
  position: absolute;
  z-index: 1;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 280px;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;

  @media (min-width: 730px) {
    height: 350px;
  }

  @media (min-width: 900px) {
    height: 100%;
    width: 600px;
    right: 0;
    left: auto;
  }
  @media (min-width: 1278px) {
    width: 768px;
  }
`;

const StlCopyInner = styled.div`
  width: 100%;
  max-width: 540px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-self: end;
  color: white;
  position: relative;
  bottom: 30px;
  padding: 10px;

  h1,
  h2 {
    margin: 0 0 20px 0;
  }
  h3 {
    margin: 0 0 20px 0;
  }

  @media (min-width: 900px) {
    text-align: left;
    align-self: center;
    width: 400px;
    bottom: 0;
    left: 50px;

    h1,
    h2 {
      margin: 0 0 32px 0;
    }
  }
  @media (min-width: 1278px) {
    width: 600px;
  }
`;

const SplitHero = (slice) => {
  const theme = useTheme();

  const copy = get(slice, "primary.copy");
  const subCopy = get(slice, "primary.sub_copy");
  const imageUrl = get(slice, "primary.image.url");
  const mobileImageUrl = get(slice, "primary.image.Mobile.url");

  const isTablet = useMediaQuery(theme.breakpoints.down("900"));

  if (!copy && !imageUrl) {
    return null;
  }

  const backgroundImage = isTablet ? mobileImageUrl || imageUrl : imageUrl;
  const diagonalImage = isTablet ? mobileDiagonal : desktopDiagonal;

  return (
    <StlRoot>
      <StlInner>
        <StlImagePanel>
          <StlBackgroundImage imageUrl={backgroundImage} />
        </StlImagePanel>
        <StlCopyPanel
          style={{
            background: `url(${diagonalImage})`,
          }}
        >
          <StlCopyInner>
            {copy && <PrismicRichText render={copy} />}
            {subCopy && <PrismicRichText render={subCopy} />}
          </StlCopyInner>
        </StlCopyPanel>
      </StlInner>
    </StlRoot>
  );
};

export default SplitHero;
